import $ from 'jquery';
import _ from 'underscore';
import PropTypes from 'prop-types';
import Promise from 'bluebird';
import React from 'react';

import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
// eslint-disable-next-line
import { HotelCenterIntelligence as HotelCenterIntelligencePromise } from '@bingads-webui-campaign-legacy/hotel-center-intelligence/intelligence-ui-next';
// eslint-disable-next-line
import state from '@bingads-webui-component-legacy/state/index';

import {
  getIntelligencePageStyles,
  getFeedUploadStyles,
  getFeedStatusStyles,
  getMatchReportStyles,
} from '../../style';

import { StyledHotelCenterCalloutExtensionPage } from './ad-extension/callout-extension-page';


const p$daterange = () => Promise.resolve(state.get('$daterange'));

class HotelCenterIntelligenceNew extends React.PureComponent {
  componentDidMount() {
    HotelCenterIntelligencePromise.then((HotelCenterIntelligence) => {
      const View = _.property(this.props.viewName)(HotelCenterIntelligence);
      this.view = new View({
        isForVNext: true,
        isNewEntitySelector: true,
        p$daterange,
        perfMarker: this.props.perfMarker,
      });
      $('#hotel-center-intelligence').append(this.view.render().$el);
    });
  }
  render() {
    return (
      <div id="hotel-center-intelligence" className={this.props.styleClassName} />
    );
  }
}

HotelCenterIntelligenceNew.propTypes = {
  styleClassName: PropTypes.string.isRequired,
  viewName: PropTypes.string.isRequired,
  perfMarker: PropTypes.string.isRequired,
};

const FeedUploadPage = props => (<HotelCenterIntelligenceNew viewName="FeedUpload" styleClassName={props.classes.FeedUpload} perfMarker={props.perfMarker} />);
FeedUploadPage.propTypes = {
  classes: PropTypes.shape({
    FeedUpload: PropTypes.object.isRequired,
  }).isRequired,
  perfMarker: PropTypes.string.isRequired,
};
export const StyledFeedUploadPage = withDefaultStyles(FeedUploadPage, getFeedUploadStyles);

export const StyledCalloutExtensionsPage = StyledHotelCenterCalloutExtensionPage;

const BookingReportPage = props => (<HotelCenterIntelligenceNew viewName="BookingReport" styleClassName={props.classes.BookingReport} perfMarker={props.perfMarker} />);
BookingReportPage.propTypes = {
  classes: PropTypes.shape({
    BookingReport: PropTypes.object.isRequired,
  }).isRequired,
  perfMarker: PropTypes.string.isRequired,
};
export const StyledBookingReportPage = withDefaultStyles(BookingReportPage, getIntelligencePageStyles);

const ShareOfVoicePage = props => (<HotelCenterIntelligenceNew viewName="ShareOfVoice" styleClassName={props.classes.ShareOfVoice} perfMarker={props.perfMarker} />);
ShareOfVoicePage.propTypes = {
  classes: PropTypes.shape({
    ShareOfVoice: PropTypes.object.isRequired,
  }).isRequired,
  perfMarker: PropTypes.string.isRequired,
};
export const StyledShareOfVoicePage = withDefaultStyles(ShareOfVoicePage, getIntelligencePageStyles);

const FeedStatusPage = props => (<HotelCenterIntelligenceNew viewName="FeedStatus" styleClassName={props.classes.FeedStatus} perfMarker={props.perfMarker} />);
FeedStatusPage.propTypes = {
  classes: PropTypes.shape({
    FeedStatus: PropTypes.object.isRequired,
  }).isRequired,
  perfMarker: PropTypes.string.isRequired,
};
export const StyledFeedStatusPage = withDefaultStyles(FeedStatusPage, getFeedStatusStyles);

const MatchReportPage = props => (<HotelCenterIntelligenceNew viewName="MatchReport" styleClassName={props.classes.MatchReport} perfMarker={props.perfMarker} />);
MatchReportPage.propTypes = {
  classes: PropTypes.shape({
    MatchReport: PropTypes.object.isRequired,
  }).isRequired,
  perfMarker: PropTypes.string.isRequired,
};
export const StyledMatchReportPage = withDefaultStyles(MatchReportPage, getMatchReportStyles);
